import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import 'echarts-extension-gmap';
import { mapColors } from 'app/stores/ui/agentur.maps.ui.store';
import { DvsSeriesOption, EchartMap } from 'app/components/maps/EchartMap';
import colors from 'assets/scss/colors.module.scss';

const vdDef = [
	{ vdId: 'B', name: 'Berlin', color: mapColors[0] },
	{ vdId: 'F', name: 'Frankfurt', color: mapColors[1] },
	{ vdId: 'H', name: 'Hannover', color: mapColors[2] },
	{ vdId: 'K', name: 'Köln', color: mapColors[3] },
	{ vdId: 'L', name: 'Leipzig', color: mapColors[4] },
	{ vdId: 'S', name: 'Stuttgart', color: mapColors[5] },
	{ vdId: 'M', name: 'München', color: mapColors[6] },
	{ vdId: 'N', name: 'Nürnberg', color: mapColors[8] },
	{ vdId: 'Nord', name: 'Verden', color: mapColors[8] },
];

const gsDef = [
	{
		vdId: 'B',
		gsId: 'B',
		name: 'Berlin',
		coord: { lat: 52.52, lng: 13.405 },
	},
	{
		vdId: 'B',
		gsId: 'BB',
		name: 'Brandenburg',
		coord: { lat: 52.4125, lng: 12.5316 },
	},
	{
		vdId: 'B',
		gsId: 'CB',
		name: 'Cottbus',
		coord: { lat: 51.7563, lng: 14.3329 },
	},
	{
		vdId: 'B',
		gsId: 'MD',
		name: 'Magdeburg',
		coord: { lat: 52.1205, lng: 11.6276 },
	},
	{
		vdId: 'B',
		gsId: 'NB',
		name: 'Neubrandenburg',
		coord: { lat: 53.5569, lng: 13.2613 },
	},
	{
		vdId: 'B',
		gsId: 'P',
		name: 'Potsdam',
		coord: { lat: 52.3906, lng: 13.0645 },
	},
	{
		vdId: 'B',
		gsId: 'SN',
		name: 'Schwerin',
		coord: { lat: 53.6355, lng: 11.4167 },
	},
	{
		vdId: 'F',
		gsId: 'F',
		name: 'Frankfurt',
		coord: { lat: 50.1109, lng: 8.6821 },
	},
	{
		vdId: 'F',
		gsId: 'GI',
		name: 'Gießen',
		coord: { lat: 50.5841, lng: 8.6784 },
	},
	{
		vdId: 'F',
		gsId: 'KO',
		name: 'Koblenz',
		coord: { lat: 50.3569, lng: 7.5886 },
	},
	{
		vdId: 'F',
		gsId: 'KS',
		name: 'Kassel',
		coord: { lat: 51.3127, lng: 9.4797 },
	},
	{
		vdId: 'F',
		gsId: 'MZ',
		name: 'Mainz',
		coord: { lat: 49.9929, lng: 8.2473 },
	},
	{
		vdId: 'F',
		gsId: 'SB',
		name: 'Saarbrücken',
		coord: { lat: 49.2402, lng: 6.9969 },
	},
	{
		vdId: 'F',
		gsId: 'WI',
		name: 'Wiesbaden',
		coord: { lat: 50.0826, lng: 8.24 },
	},
	{
		vdId: 'H',
		gsId: 'GOE',
		name: 'Göttingen',
		coord: { lat: 51.5413, lng: 9.9158 },
	},
	{
		vdId: 'H',
		gsId: 'H',
		name: 'Hannover',
		coord: { lat: 52.3759, lng: 9.732 },
	},
	{
		vdId: 'H',
		gsId: 'HB',
		name: 'Bremen',
		coord: { lat: 53.0793, lng: 8.8017 },
	},
	{
		vdId: 'H',
		gsId: 'HH',
		name: 'Hamburg',
		coord: { lat: 53.5511, lng: 9.9937 },
	},
	{
		vdId: 'H',
		gsId: 'KI',
		name: 'Kiel',
		coord: { lat: 54.3233, lng: 10.1228 },
	},
	{
		vdId: 'H',
		gsId: 'OL',
		name: 'Oldenburg',
		coord: { lat: 53.1435, lng: 8.2146 },
	},
	{
		vdId: 'H',
		gsId: 'OS',
		name: 'Osnabrück',
		coord: { lat: 52.2799, lng: 8.0472 },
	},
	{
		vdId: 'K',
		gsId: 'AC',
		name: 'Aachen',
		coord: { lat: 50.7753, lng: 6.0839 },
	},
	{
		vdId: 'K',
		gsId: 'D',
		name: 'Düsseldorf',
		coord: { lat: 51.2277, lng: 6.7735 },
	},
	{
		vdId: 'K',
		gsId: 'DO',
		name: 'Dortmund',
		coord: { lat: 51.5136, lng: 7.4653 },
	},
	{
		vdId: 'K',
		gsId: 'E',
		name: 'Essen',
		coord: { lat: 51.4556, lng: 7.0116 },
	},
	{
		vdId: 'K',
		gsId: 'KBN',
		name: 'Köln',
		coord: { lat: 50.9375, lng: 6.9603 },
	},
	{
		vdId: 'K',
		gsId: 'MS',
		name: 'Münster',
		coord: { lat: 51.9607, lng: 7.6261 },
	},
	{
		vdId: 'K',
		gsId: 'NR',
		name: 'Niederrhein',
		coord: { lat: 51.3388, lng: 6.5853 },
	},
	{
		vdId: 'K',
		gsId: 'W',
		name: 'Wuppertal',
		coord: { lat: 51.2562, lng: 7.1508 },
	},
	{
		vdId: 'L',
		gsId: 'BZ',
		name: 'Bautzen',
		coord: { lat: 51.18, lng: 14.434 },
	},
	{
		vdId: 'L',
		gsId: 'C',
		name: 'Chemnitz',
		coord: { lat: 50.8278, lng: 12.9214 },
	},
	{
		vdId: 'L',
		gsId: 'DD',
		name: 'Dresden',
		coord: { lat: 51.0504, lng: 13.7373 },
	},
	{
		vdId: 'L',
		gsId: 'EF',
		name: 'Erfurt',
		coord: { lat: 50.9848, lng: 11.0299 },
	},
	{
		vdId: 'L',
		gsId: 'HAL',
		name: 'Halle',
		coord: { lat: 51.4828, lng: 11.969 },
	},
	{
		vdId: 'L',
		gsId: 'J',
		name: 'Jena',
		coord: { lat: 50.9271, lng: 11.5892 },
	},
	{
		vdId: 'L',
		gsId: 'L',
		name: 'Leipzig',
		coord: { lat: 51.3397, lng: 12.3731 },
	},
	// {
	//     "vdId": "L",
	//     "gsId": "MEI",
	//     "name": "Meissen",
	//     "coord": { "lat": 51.1613, "lng": 13.4735 }
	// },
	// {
	//     "vdId": "L",
	//     "gsId": "SHL",
	//     "name": "Suhl",
	//     "coord": { "lat": 50.6091, "lng": 10.6940 }
	// },
	{
		vdId: 'L',
		gsId: 'Z',
		name: 'Zwickau',
		coord: { lat: 50.7189, lng: 12.4939 },
	},
	{
		vdId: 'M',
		gsId: 'A',
		name: 'Augsburg',
		coord: { lat: 48.3705, lng: 10.8978 },
	},
	{
		vdId: 'M',
		gsId: 'IN',
		name: 'Ingolstadt',
		coord: { lat: 48.7656, lng: 11.4237 },
	},
	{
		vdId: 'M',
		gsId: 'KE',
		name: 'Kempten',
		coord: { lat: 47.7267, lng: 10.3139 },
	},
	{
		vdId: 'M',
		gsId: 'LA',
		name: 'Landshut',
		coord: { lat: 48.5442, lng: 12.1469 },
	},
	{
		vdId: 'M',
		gsId: 'M',
		name: 'München',
		coord: { lat: 48.1351, lng: 11.582 },
	},
	{
		vdId: 'M',
		gsId: 'RO',
		name: 'Rosenheim',
		coord: { lat: 47.8561, lng: 12.1225 },
	},
	{
		vdId: 'M',
		gsId: 'WM',
		name: 'Weilheim',
		coord: { lat: 47.8415, lng: 11.1508 },
	},
	{
		vdId: 'N',
		gsId: 'BT',
		name: 'Bayreuth',
		coord: { lat: 49.9427, lng: 11.5761 },
	},
	{
		vdId: 'N',
		gsId: 'N',
		name: 'Nürnberg',
		coord: { lat: 49.4521, lng: 11.0767 },
	},
	{
		vdId: 'N',
		gsId: 'PA',
		name: 'Passau',
		coord: { lat: 48.5667, lng: 13.4319 },
	},
	{
		vdId: 'N',
		gsId: 'R',
		name: 'Regensburg',
		coord: { lat: 49.0134, lng: 12.1016 },
	},
	{
		vdId: 'N',
		gsId: 'WUE',
		name: 'Würzburg',
		coord: { lat: 49.7913, lng: 9.9534 },
	},
	{
		vdId: 'S',
		gsId: 'FR',
		name: 'Freiburg',
		coord: { lat: 47.999, lng: 7.8421 },
	},
	{
		vdId: 'S',
		gsId: 'GP',
		name: 'Göppingen',
		coord: { lat: 48.7038, lng: 9.6523 },
	},
	{
		vdId: 'S',
		gsId: 'HN',
		name: 'Heilbronn',
		coord: { lat: 49.1427, lng: 9.2109 },
	},
	{
		vdId: 'S',
		gsId: 'KA',
		name: 'Karlsruhe',
		coord: { lat: 49.0069, lng: 8.4037 },
	},
	{
		vdId: 'S',
		gsId: 'OG',
		name: 'Offenburg',
		coord: { lat: 48.4738, lng: 7.9443 },
	},
	{
		vdId: 'S',
		gsId: 'RT',
		name: 'Reutlingen',
		coord: { lat: 48.4914, lng: 9.2043 },
	},
	{
		vdId: 'S',
		gsId: 'S',
		name: 'Stuttgart',
		coord: { lat: 48.7758, lng: 9.1829 },
	},
	{
		vdId: 'S',
		gsId: 'UL',
		name: 'Ulm',
		coord: { lat: 48.4011, lng: 9.9876 },
	},
];

export const GeschaefstellenMap = observer(() => {
	const { uiStore } = useStore();

	var convertData = function (data: any[]) {
		var res = [];
		for (var i = 0; i < data.length; i++) {
			const lat = data[i].coord.lat;
			const lng = data[i].coord.lng;
			if (lat && lat > 0 && lng && lng > 0) {
				const geoCoord = [lat, lng];
				if (geoCoord) {
					const vd = vdDef.find((v) => v.vdId === data[i].vdId);
					if (!vd) {
						console.log('no vd for ' + data[i].gsId);
					} else {
						res.push(
							geoCoord
								.concat(50)
								.concat(vd!.color)
								.concat(data[i].name + ` [${vd.vdId}] `),
						);
					}
				}
			}
		}
		return res;
	};

	// center: [10.2656, 51.0939,],
	// zoom: 8,
	let series: DvsSeriesOption[] = [
		{
			type: 'scatter',
			coordinateSystem: 'gmap',
			symbolSize: 50,
			symbol: 'pin',
			data: convertData(gsDef),
			colorBy: 'data',
			clip: false,

			itemStyle: {
				color: (p: any) => {
					// console.log(p)
					return p.data[3];
				},
			},
			emphasis: {
				// itemStyle: {
				//     // Color in emphasis state.
				//     color: 'red'
				// },
				label: {
					show: true,
					// Text in emphasis.
					formatter: (p: any) => {
						return p.value[4] || '';
					},
					padding: 10,
					color: colors.text,
					backgroundColor: colors.white,
					borderRadius: 5,
				},
			},
			encode: {
				symbolSize: 2,
				lng: 1,
				lat: 0,
				// 'itemStyle.color': 3,
				label: 4,
			},
		},
	];

	return <>{series && <EchartMap series={series} itemCountOn={'DVS Agenturen'} />}</>;
});
